/* src/app/expenses/presenters/expense-entry/expense-entry.component.scss */
:host {
  display: block;
}
.expense-entry {
  width: min(36rem, 92vw);
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}
.expense-entry-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem 0.5rem;
}
.expense-entry-header h2 {
  margin: 0;
  font-size: 1.25rem;
}
.expense-entry-body {
  overflow: auto;
  padding: 0 0.75rem 0.5rem;
  flex: 1 1 auto;
}
.expense-entry-section {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  padding: 0.5rem 0.25rem 0.75rem;
}
.expense-entry-summary-info {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem 1.5rem;
  padding: 0.35rem 0.15rem 0.15rem;
  font-size: 0.95rem;
  font-weight: 600;
}
.expense-entry-summary-line {
  white-space: nowrap;
}
.expense-entry-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}
.expense-entry-row > * {
  flex: 1 1 10rem;
}
.expense-entry-rates {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.5rem 1rem;
  font-size: 0.9rem;
}
.expense-entry-rates label {
  font-weight: 600;
  margin-right: 0.35rem;
}
.expense-entry-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  padding: 0.75rem 1rem 1rem;
  border-top: 1px solid var(--p-content-border-color, #dee2e6);
}
.location-link {
  cursor: pointer;
  color: var(--p-primary-color, #3b82f6);
  text-decoration: underline;
}
.attachment-list {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  margin-top: 0.5rem;
}
.attachment-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}
.attachment-link {
  color: var(--p-primary-color, #3b82f6);
  text-decoration: underline;
  cursor: pointer;
  word-break: break-word;
}
:host ::ng-deep .p-floatlabel.receipt-float-error > label,
:host ::ng-deep p-floatlabel.receipt-float-error > label {
  color: var(--p-floatlabel-invalid-color, #e24c4c) !important;
}
:host ::ng-deep .p-floatlabel.receipt-float-error .p-inputtext,
:host ::ng-deep p-floatlabel.receipt-float-error .p-inputtext {
  border-color: var(--p-inputtext-invalid-border-color, #e24c4c) !important;
}
:host ::ng-deep .p-floatlabel.receipt-float-error .p-select,
:host ::ng-deep p-floatlabel.receipt-float-error .p-select {
  border-color: var(--p-select-invalid-border-color, #e24c4c) !important;
}
:host ::ng-deep .p-floatlabel.receipt-float-error .p-select-label.p-placeholder,
:host ::ng-deep p-floatlabel.receipt-float-error .p-select-label.p-placeholder {
  color: var(--p-select-invalid-placeholder-color, #e24c4c) !important;
}
/*# sourceMappingURL=expense-entry.component.css.map */
